import React, { useEffect, useRef, useState } from "react";
import { Form, Modal, Spin, Tree } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { assignRole, fetchAssignedRoles } from "../../../../features/dropdown/dropdownSlice";

const PermissionModal = ({ isModalOpen, setIsModalOpen, prodd }) => {
  const handleOk = () => {
    setIsModalOpen(false); 
    setExpandedKeys([]); 
    setTreeData([{ title: "Tree Node", key: "0", isLeaf: false,disableCheckbox: true }]);
  };
  const navigate = useNavigate();

  const [formData, setFormData] = useState({ ...prodd });

  const handleCancel = () => {
    setIsModalOpen(false); 
    setExpandedKeys([]); 
    setTreeData([{ title: "Tree Node", key: "0", isLeaf: false,disableCheckbox: true }]);
  };

  const [form] = Form.useForm();
  const formRef = useRef(null);
  const { user } = useSelector((state) => state.auth);

  const {  loading } = useSelector((state) => state.dropdown);
  const dispatch = useDispatch();

  const [treeData, setTreeData] = useState([
    { title: "Tree Node", key: "0", isLeaf: false,disableCheckbox: true },  
  ]);
  const [expandedKeys, setExpandedKeys] = useState([]);
  const [checkedKeys, setCheckedKeys] = useState([]);

 
  const fetchChildren = async (key) => {
    try { 
      const res = await dispatch(
        fetchAssignedRoles({
          userId: prodd?.usrId,
          node: key === "0" ? "xnode_1" : key,
        })
      ); 
      if (res?.payload) { 
        const checkedKeysFromResponse = res?.payload
          .filter((item) => item?.checked)
          .map((item) => item?.id);

          setCheckedKeys(checkedKeysFromResponse);

        return res?.payload?.map((item) => ({
          title: item?.text,
          key: item?.id,
          isLeaf: item?.cls === "file",
          disableCheckbox: item?.cls === "folder", 
          cls: item?.cls,
        }));
      }
      return [];
    } catch (error) {
      console.error("Error fetching children: ", error);
      return [];
    }
  };
 

  const onExpand = async (expandedKeys, { expanded, node }) => { 
   
    if (expanded) {   
      setExpandedKeys(expandedKeys);  
      if (expandedKeys.includes("applications") && expandedKeys.includes("0")) { 
        setExpandedKeys(prevKeys => {  
          return ["applications", "0", node.key];  
        });
      } else if (expandedKeys.includes("reports") && expandedKeys.includes("0")) { 
        setExpandedKeys(prevKeys => {  
          return ["reports", "0", node.key];  
        });
      }  
      
      const children = await fetchChildren(node?.key); 
      setTreeData((prevTreeData) =>
        updateTreeData(prevTreeData, node?.key, children) 
      );
    } 
    else{  
      setExpandedKeys(expandedKeys); 
    }
  };
  
  const updateTreeData = (list, key, children) => {
    return list.map((node) => {
      if (node?.key === key) {
        return { ...node, children }; 
      }
      if (node?.children) {
        return {
          ...node,
          children: updateTreeData(node?.children, key, children),
        };
      }
      return node;
    });
  };


  const onCheck = async (checkedKeysValue, { checked, node }) => {
    const res = await dispatch(
      assignRole({
        rolesId: node?.key,
        nodeValue: checked ? true : false,
        userId: prodd?.usrId,
      })
    ); 
    if (res?.payload?.success) {
      await toast.success("Role assignedd successfully");
    } else {
      toast.error("Error assigning role, please try again");
    }
    await setCheckedKeys(checkedKeysValue);
  };

  useEffect(() => {
    setFormData(prodd);
  }, [prodd]);


  return (
    <>
      <Modal
        className="modal-btn mod-height mod-footer users activity-header activity-close"
        title={`Edit permissions for ${prodd?.usrUsername}`}
        open={isModalOpen} 
        onCancel={handleCancel}
        onOk={handleOk}
        width={800}
      >
        <Spin spinning={loading}>
          <Tree
            checkable
            onExpand={onExpand}
            expandedKeys={expandedKeys}
            checkedKeys={checkedKeys}
            onCheck={onCheck}
            treeData={treeData}
          />
        </Spin>
      </Modal>
    </>
  );
};

export default PermissionModal;
